import { get_user_profile, get_token, set_user_profile } from '@/router';

export default {
                cancelEdit() {
            this.$router.push(this.get_return_path());
        },

        validate_user_payload() {
            if (!this.form.first_name || !this.form.last_name) {
                return "First name and last name are required.";
            }

            return "";
        },

        get_update_context(profile) {
            const raw_user_id = this.is_managed_user_edit
                ? this.selected_user_id
                : this.get_selected_profile_id(profile);
            const safe_user_id = this.parse_user_id(raw_user_id);

            return ({
                auth_token: get_token(),
                profile,
                profile_update_url: this.get_endpoint_url(this.update_user_url, safe_user_id, "update"),
                safe_user_id,
                user_update_url: this.get_user_update_url(safe_user_id)
            });
        },

        get_user_update_url(safe_user_id) {
            const base_url = this.is_managed_user_edit
                ? this.user_management_url
                : this.view_user_url;

            return this.get_endpoint_url(base_url, safe_user_id, "update");
        },

        get_update_context_error(context) {
            if (!context.safe_user_id || !context.auth_token || !context.user_update_url) {
                return "Unable to save user details.";
            }

            if (this.is_managed_user_edit && !this.user_management_url) {
                console.warn("VUE_APP_USER_MANAGEMENT_URL is not configured.");
                return "Unable to save user details.";
            }

            if (!this.is_managed_user_edit && !this.view_user_url) {
                console.warn("VUE_APP_VIEW_USER_URL or VUE_APP_USER_MANAGEMENT_URL is not configured.");
                return "Unable to save user details.";
            }

            return "";
        },

        build_json_request(url, body) {
            return new Request(url, {
                method: "POST",
                headers: this.get_auth_headers(true),
                body: JSON.stringify(body)
            });
        },

        async save_user_details(user_update_url) {
            const user_request = this.build_json_request(user_update_url, {
                "first_name": this.form.first_name,
                "last_name": this.form.last_name
            });
            const user_response = await fetch(user_request);
            await this.get_response_data(user_response, "Unable to save user.");
        },

        async save_profile_details(profile_update_url) {
            if (!profile_update_url) return;

            const profile_request = this.build_json_request(profile_update_url, {
                "phone_number": this.form.phone || "",
                "session_policy": this.form.session_policy || "default",
                "session_timeout_minutes": this.form.session_policy === "custom" ? Number(this.form.session_timeout_minutes) : null,
                "client_app": process.env.VUE_APP_CLIENT_APP || "vsi_perpetual"
            });
            const profile_response = await fetch(profile_request);
            await this.get_response_data(profile_response, "Unable to save user profile.");
        },

        sync_current_user_profile(profile) {
            if (this.is_managed_user_edit) return;

            set_user_profile({
                ...(profile || {}),
                first_name: this.form.first_name,
                last_name: this.form.last_name,
                email: this.form.email,
                phone_number: this.form.phone
            });
        },

        validate_update_request(context) {
            const validation_error = this.validate_user_payload();

            if (validation_error) return validation_error;
            return this.get_update_context_error(context);
        },

        async persist_user_update(context) {
            await this.save_user_details(context.user_update_url);
            await this.save_profile_details(context.profile_update_url);
            this.sync_current_user_profile(context.profile);
        },

        async update_user() {
            const context = this.get_update_context(get_user_profile());
            const request_error = this.validate_update_request(context);

            if (request_error) {
                this.form_error = request_error;
                return false;
            }

            this.is_saving = true;
            this.form_error = "";

            try {
                await this.persist_user_update(context);
                return true;
            } catch (error) {
                this.form_error = error.message || "Unable to save user details.";
                return false;
            } finally {
                this.is_saving = false;
            }
        },

        async saveProfile() {
            const did_save = await this.update_user();

            if (did_save) {
                this.$router.push(this.get_return_path());
            }
        }
    
};
